import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ReportGetter } from '../../directives/ReportGetter';
import { ReportBuilderService } from '../../services/report-builder.service';
import { Router } from '@angular/router';
import { NavigationService } from '../../../../shared/services/navigation.service';
import { FileService } from '../../../../shared/services/file.service';
import { GuardService } from '../../../../shared/services/guard.service';
import { ModuleService } from '../../../../shared/services/module.service';
import { IS_PRODUCT_SAFETY_PROJECT, IS_TRS_PROJECT } from '../../../../../current-project';
import { TinyHelper } from '../../../../shared/helpers/tiny.helper';

@Component({
    selector: 'app-report-form',
    templateUrl: './report-form.component.html',
    styleUrls: ['./report-form.component.scss'],
    standalone: false
})
export class ReportFormComponent extends ReportGetter {
    IS_TRS_PROJECT = IS_TRS_PROJECT;
    IS_PRODUCT_SAFETY_PROJECT = IS_PRODUCT_SAFETY_PROJECT;

    @Output() signature = new EventEmitter<string>();

    constructor(
        builder: ReportBuilderService,
        dialog: MatDialog,
        router: Router,
        navigation: NavigationService,
        guard: GuardService,
        moduleService: ModuleService,
        private fileService: FileService
    ) {
        super(builder, dialog, router, navigation, guard, moduleService);
    }

    get innerWidth(): number {
        return window.innerWidth;
    }

    isGuidanceOpen(id: string): boolean {
        return this.builder.guidanceRef.some(e => e.id === id);
    }

    protected uploadDocument(documents: FileList): void {
        const pdfDocuments = Array.from(documents).filter(file => file.type === 'application/pdf');
        this.documents = pdfDocuments.length > 0 ? [pdfDocuments[0]] : [];
    }

    protected clearDocument(): void {
        this.documents = [];
    }

    /**
     * Downloads the document from the server.
     * If the document is a File, it will not be downloaded as it means it was uploaded in the current session.
     */
    protected async downloadDocument(): Promise<void> {
        const document = this.documents[0];
        if (document instanceof File) {
            return;
        }

        // Old attachments use name instead of id
        const key = document.id ? `${document.id}.pdf` : document.name;
        const report = await this.fileService.getReportDocument(this.report.id, key);
        await this.fileService.downloadAttachment(report, document.name);
    }

    protected getFile(): File {
        return this.documents[0] as File;
    }

    protected getFileLastModifiedDate(file: File): Date {
        return new Date(file.lastModified);
    }

    protected getFileSize(file: File): string {
        return TinyHelper.convertBytesToMB(file.size);
    }
}
